<div class="tailoredSolutionWrap">
    <div class="maxContainerWidth">
        <div class="contentWrap flex flex-col md:justify-center">
            <h4 class="text-gradient md:text-center">Features </h4>
            <h2 class="md:text-center pb-4 md:pb-0 md:max-w-full max-w-[300px]">State of the Art Logistics Solution </h2>

        </div>
        <div class="solutionWrap w-full md:w-[880px] flex flex-col sm:flex-row">
            <div *ngFor="let feature of features" class="solution w-full md:min-h-[216px] sm:w-[298px] md:w-[380px] lg:w-[427px] flex flex-col sm:flex-row justify-center item-center lg:mx-auto py-5 md:py-0">
                <div class="flex items-center md:justify-center ">
                    <div class="flex flex-col ">
                        <div class="flex items-center gap-2 mb-4">
                            <img class=" my-1 h-[28px] w-[28px]" [src]="feature.icon">
                            <h4>{{feature.title}}</h4>
                        </div>
                        <p class="md:max-w-[249px]">{{feature.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>